import { Dataset } from "@/types/dataset";

import SliderInput from "./SliderInput";

interface Props {
  data: Dataset;
  max: number;
  onChangeSlider?: (value: number[]) => void;
  onChangeInput?: (value: number) => void;
}

export const RankSlider = ({
  data,
  max,
  onChangeSlider,
  onChangeInput
}: Props) => {
  return (
    <div className="flex flex-col gap-2 w-full">
      <p className="text-xs text-txtPlaceholder">Max Ranking</p>
      <SliderInput
        disabled={!data.style.rankConfig?.isEnabled || max <= 1}
        valueSlider={[data.style.rankConfig?.maxRanking ?? 1]}
        onChangeSlider={onChangeSlider}
        valueInput={data.style.rankConfig?.maxRanking ?? 1}
        onChangeInput={onChangeInput}
        max={max}
      />
    </div>
  );
};
